module.exports = __webpack_public_path__ + "static/media/obx_smallLogo.23ade412.jpeg";